import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import { BlogDetails } from "../components/blog/BlogDetails";
import { Header, Footer } from "../shared";

const SingleBlogDetailsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <BlogDetails />
      <Footer />
    </div>
  );
};

export default SingleBlogDetailsPage;
